<template>
<div class="component" v-if="file!=null">
    <div class="card">
        <div class="has-text-centered fileHeader">

            {{file.fileName}}
        </div>

        <div class="card-content">
            <div class="content">
                <div class="tabs is-centered is-boxed">
                    <ul>
                        <li :class="{'is-active':activeTab=='overview'}" @click="activeTab='overview'"><a>Übersicht</a></li>
                        <li :class="{'is-active':activeTab=='files'}" @click="activeTab='files'"><a>Erstellte Dateien</a></li>
                    </ul>
                </div>
                <div class="fileInformation">
                    <div v-if="activeTab=='overview'">
                        Erstellt von {{file.owner.name}}
                    </div>

                    <div v-if="activeTab=='files'">
                        <div class="" v-if="file.processed_files.length <1">Keine Zusatzdateien vorhanden</div>
                                               <div v-else> Zusätzliche Dateien:</div>

                        <div v-for="processedFile in file.processed_files" @click="downloadProcessedFile(processedFile.id)"><a>{{processedFile.processedFileName}}</a></div>

                    </div>

                </div>
            </div>
        </div>
        <footer class="card-footer">
            <a class="card-footer-item" @click="downloadFile()">Download</a>
            <a class="card-footer-item" @click="editFile()">Verarbeiten</a>
            <a class="card-footer-item" @click="deleteFile()">Löschen</a>
        </footer>
    </div>

</div>
</template>

<script>
export default {
    name: 'file',
    props: ["file"],
    mounted: function () {},
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            activeTab: "overview",
        }
    },
    methods: {
        editFile() {
            let postData = {
                "fileId": this.file.id
            }
            this.callApi("/file/edit", "post", postData).then(function (response) {
                this.refresh();

            }.bind(this))
        },

        downloadFile() {
            let postData = {
                "fileId": this.file.id
            }

            let headerData = {
                'Accept': '*',
                'Authorization': 'Bearer ' + localStorage.bearertoken,
                'responseType': 'arraybuffer'
            }
            this.downloadFiles("/file/download", "post", postData, headerData).then(function (response) {
                let disposition = response.headers['content-disposition']
                //let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
                console.log("--" + disposition)
                let blob = new Blob([response.data], {
                    type: 'application/*'
                })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                var filename = response.headers['content-disposition'].split('=')[1].replace(/^\"+|\"+$/g, '')
                var extension = response.headers['content-type'].split('/')[1].replace(/^\"+|\"+$/g, '')
                link.download = filename + "." + extension

                link.click()
            }.bind(this))
        },
        downloadProcessedFile(processedFileId) {
            let postData = {
                "processedFileId": processedFileId
            }

            let headerData = {
                'Accept': '*',
                'Authorization': 'Bearer ' + localStorage.bearertoken,
                'responseType': 'arraybuffer'
            }
            this.downloadFiles("/file/downloadprocessedfile", "post", postData, headerData).then(function (response) {
                let disposition = response.headers['content-disposition']
                //let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
                console.log("--" + disposition)
                let blob = new Blob([response.data], {
                    type: 'application/*'
                })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                var filename = response.headers['content-disposition'].split('=')[1].replace(/^\"+|\"+$/g, '')
                var extension = response.headers['content-type'].split('/')[1].replace(/^\"+|\"+$/g, '')
                link.download = filename + "." + extension

                link.click()
            }.bind(this))
        },
        deleteFile() {
            let postData = {
                "fileId": this.file.id
            }
            this.callApi("/file/delete", "post", postData).then(function (response) {
                this.refresh();
            }.bind(this))
        },
        refresh() {
            this.$emit("refreshFileList")
        }
    },
    computed: {
        isProjectAdmin() {

        },
        openProject() {
            this.$router.push({
                name: 'Project',
                params: {
                    id: this.project.id
                }
            })

        },

    },
}
</script>

<style scoped>
.component {
    margin-top: 1rem;
}

.fileInformation {
    min-height: 3rem;

}

.fileHeader {
    font-weight: bold;
    line-break: anywhere;
}
</style>
